export const environment = {
    production: false,
    sUrl: "https://beta.usa.api-comercial.sw-hmp.com/api/v1/"
    //sUrl: "http://localhost:3000/api/v1/"
    //sUrl: "https://beta.usa.api-comercial.sw-hmp.com/api/v1/"
    //sUrl: "https://beta.api-modable.auth.sw-hmp.com/api/v1/"
};
